import { REQUIRED_PARAMS_FOR_TRX_TYPE } from '@engine/features/terminal/terminal_dependent_variables';
import { changeCheckboxStatus } from '@engine/lib/utility/change_checkbox_status';
import { toggleDisabledAttribute } from '@engine/lib/utility/toggle_disabled_attribute';

function applySplitPaymentConfiguration() {
  var checkbox_state = $('#feature_supports_split_payments').is(':checked');
  var allowed_trx_types_for_split_payments = ['sale', 'sale3d', 'intersolve', 'fashioncheque', 'container_store'];
  var allowed_checkboxes = allowed_trx_types_for_split_payments.map(function (type) {
    return '#transaction_type_' + type;
  }).join(',');
  var $all_checkboxes = $('#supported_transaction_types input[type=checkbox]');
  var disabled_trx_types_for_split_payments = $all_checkboxes.not(allowed_checkboxes);
  toggleDisabledAttribute(disabled_trx_types_for_split_payments, checkbox_state);
}

function accountVerificationWithoutEnabledAvs(transaction_type) {
  return transaction_type === 'account_verification' && $('#feature_enable_avs').is(':not(:checked)');
}

function listenForTransactionTypesChange() {
  $.each(REQUIRED_PARAMS_FOR_TRX_TYPE, function (transaction_type, params_for_type) {
    var required_api_params = params_for_type.map(function (attr) {
      return 'required_api_param_' + attr;
    });
    $('#transaction_type_' + transaction_type).on('change', function () {
      if (accountVerificationWithoutEnabledAvs(transaction_type)) {
        return;
      }

      changeCheckboxStatus(required_api_params, true);
    });
    $.each(required_api_params, function (index, param) {
      $('#' + param).on('change', function () {
        if (accountVerificationWithoutEnabledAvs(transaction_type)) {
          return;
        }

        $('#transaction_type_' + transaction_type).prop('checked', false);
      });
    });
  });
  applySplitPaymentConfiguration();
}

function listenForPaymentTypesChange() {
  var online_banking_payment_types = ['quick_payment', 'qr_payment', 'netbanking', 'alipay_qr', 'alipay', 'online_banking', 'scotiabank', 'bancomer'];
  var bank_payout_payment_types = ['bank_to_bank', 'pix', 'bsb', 'pay_id', 'pix_b2b', 'bank_to_bank_b2b'];
  var bank_codes = ['PF', 'SN', 'IT', 'BR', 'BB', 'WP', 'BN', 'PS', 'BO', 'CPI', 'BCT', 'CA', 'AI', 'SE', 'BQ', 'EF', 'BC', 'IB', 'BP', 'PE', 'SP', 'BLK', 'TRL'];
  var mapped_online_banking_payment_types = online_banking_payment_types.map(function (payment_type) {
    return 'payment_type_' + payment_type;
  });
  var mapped_bank_payout_payment_types = bank_payout_payment_types.map(function (payment_type) {
    return 'payment_type_' + payment_type;
  });
  $('#transaction_type_bank_payout').on('change', function () {
    var checked = $('#transaction_type_bank_payout').is(':checked');
    changeCheckboxStatus(mapped_bank_payout_payment_types, checked);
  });
  $('#transaction_type_online_banking').on('change', function () {
    var checked = $('#transaction_type_online_banking').is(':checked');
    changeCheckboxStatus(mapped_online_banking_payment_types, checked);
    changeCheckboxStatus(bank_codes.map(function (bank_code) {
      return 'bank_code_' + bank_code;
    }), checked);
  });
  $('#payment_type_online_banking').on('change', function () {
    var checked = $('#payment_type_online_banking').is(':checked');
    changeCheckboxStatus(bank_codes.map(function (bank_code) {
      return 'bank_code_' + bank_code;
    }), checked);
  });
  $.each(online_banking_payment_types, function (index, payment_type) {
    $('#payment_type_' + payment_type).on('change', function () {
      $('#transaction_type_online_banking').prop('checked', true);
    });
  });
  $.each(bank_payout_payment_types, function (index, payment_type) {
    $('#payment_type_' + payment_type).on('change', function () {
      $('#transaction_type_bank_payout').prop('checked', true);
    });
  });
  $.each(bank_codes, function (index, bank_code) {
    $('#bank_code_' + bank_code).on('change', function () {
      $('#payment_type_online_banking').prop('checked', true);
      $('#transaction_type_online_banking').prop('checked', true);
    });
  });
}

function listenForSupportedFeaturesChange() {
  var feature_to_required_params = {
    feature_enable_avs: ['required_api_param_address1', 'required_api_param_city', 'required_api_param_zip_code']
  };
  $.each(feature_to_required_params, function (key, value) {
    $('#' + key).on('change', function () {
      changeCheckboxStatus(feature_to_required_params[key], true);
    });
    $.each(value, function (index, param) {
      $('#' + param).on('change', function () {
        if (!$('#required_api_param_address1').is(':checked') && !$('#required_api_param_zip_code').is(':checked')) {
          $('#' + key).prop('checked', false);
        }
      });
    });
  });
  $('#feature_supports_split_payments').on('change', function () {
    var split_payment_class = 'SplitPaymentsTrafficShaper';
    var default_class = 'DefaultTrafficShaper';
    var traffic_shaper_class = $(this).is(':checked') ? split_payment_class : default_class;
    $('#terminal_traffic_shaper_class').val(traffic_shaper_class).trigger('chosen:updated');
    applySplitPaymentConfiguration();
  });
}

function listenForTrafficShaperClassChange() {
  $('#terminal_traffic_shaper_class').on('change', function () {
    var supports_split_payments = $(this).val() === 'SplitPaymentsTrafficShaper';
    $('#feature_supports_split_payments').prop('checked', supports_split_payments);
    applySplitPaymentConfiguration();
  });
}

var DependentCheckboxes = {
  listenForPaymentTypesChange: listenForPaymentTypesChange,
  listenForTransactionTypesChange: listenForTransactionTypesChange,
  listenForSupportedFeaturesChange: listenForSupportedFeaturesChange,
  listenForTrafficShaperClassChange: listenForTrafficShaperClassChange
};
export default DependentCheckboxes;